import { ChevronDown } from 'lucide-react';
import { cn } from '@rocco/utils/cn';

interface ScrollCueProps {
    /** The word above the chevron. */
    label?: string;
    className?: string;
}

/**
 * The "Scroll" cue at the foot of a full-screen hero.
 *
 * One definition, so the professional profile and the premium article carry the
 * same thing rather than two that nearly match — the article's had its own type
 * size, its own white and a `bounce` where the profile nudges, and the drift
 * was only visible side by side.
 *
 * The chevron's animation is `motion-safe`, so reduced motion gets the cue
 * without the movement.
 */
export const ScrollCue = ({ label = 'Scroll', className }: ScrollCueProps) => (
    <span
        className={cn(
            'flex flex-col items-center gap-[0.5rem] font-sans text-[0.875rem] leading-none font-medium tracking-[0.02em] text-white/80',
            className,
        )}
    >
        {label}
        <ChevronDown
            aria-hidden="true"
            className="size-[1.125rem] motion-safe:animate-[scroll-cue-nudge_2s_ease-in-out_infinite]"
        />
    </span>
);
